import { oz } from '@weft/utils';
import { MonthsSchema } from '../../../primitives';
import { RevenuePerMonthBreakdownSchema } from './revenue-per-month-breakdown';

export const RevenuePerMonthSchema = oz.record(MonthsSchema, RevenuePerMonthBreakdownSchema.optional());

export type RevenuePerMonth = oz.infer<typeof RevenuePerMonthSchema>;